import React, { useState } from 'react'
import { ReactComponent as Close } from "../assets/icons/x.svg";
import NewButton from './NewButton';
import { FileUploaderButton } from '../Components/FileUploaderButton';
import { FormTextInput } from '../Components/FormTextInput';
import { useScreenTransition } from '../Hooks/useScreenTransition';


const AddFilesAccountOrderPopUp = ({ onCancel = () => { }, onClose = () => { }, onSave = () => { }, files, pagesCount, handleFiles, handleDeleteFile,onChangePagesCount, windowSize }) => {

  const { transitionTo } = useScreenTransition();

  

  return (
    <div className='newPopUpModalWrap'>
      <div className="newPopUpModalContainer max-w-xl justify-start items-center relative">
        <h2 className="newPopUpModalTitle">Uploade Files</h2>
        <Close className="newPopUpModalCloseIcon" onClick={onClose} />

        <div className="orderaddfilesexpeditedPlusErrorWrap">
          <p className="expeditedPlusErrorText">
            Adding new file will update the total cost of the order. The order will get "On Hold" status till the approval of the new price.
          </p>
        </div>

        <div className='orderaddfilesPrimaryOptionsWrapper'>
          <h4 className="orderaddfilesPrimaryTitle">How many pages do you need translated?</h4>

          <div className="orderCountContainer">
            <p className="orderCountAuxText">{"A page is 250 words or fewer including numbers. Unsure of your page count?"} <span className="quoteSignInButton" onClick={(e) => transitionTo("/quote/details")}>Request a quote.</span></p>
            <div className="orderAddSourceFileCountInputContainer">
              <FormTextInput placeholder={"Page Count (*)"} value={pagesCount} onChange={onChangePagesCount} />
            </div>

          </div>
        </div>
        <div className='orderaddfilesPrimaryOptionsWrapper'>
        <h2 className="orderaddfilesPrimaryTitle">Uploade Files</h2>
       
        <div className='w-full'>
          <FileUploaderButton hideAddComment display text="Choose Files" files={files} handleFiles={handleFiles} handleDeleteFile={handleDeleteFile} fontSize={windowSize.width > 1024 ? 1.1 : windowSize.width > 767 ? (windowSize.orientation === 'portrait' ? 1.6 : 1.1) : (windowSize.orientation === 'portrait' ? 5 : 1.5)} />
        </div>
        </div>
        <div className='w-full flex gap-4 '>
          <NewButton width='100%' text={"Cancel"} back={true} icon={false} whiteBtn={true} onClick={onCancel} />
          <NewButton
            width='100%'
            text={"Save"}
            disabled={pagesCount==="" || files.length === 0 || files.some(el => el.status !== "complete")}
            onClick={onSave}
          />
        </div>
      </div>
    </div>
  )
}

export default AddFilesAccountOrderPopUp
